import { FeatureConfiguration } from "features";
import { CustomFeedback } from "features/customFeedback/components/CustomFeedback";

export default function (config: FeatureConfiguration) {
    config.addRoutes(config.routes.locationRoutes, [<CustomFeedback key="custom-feedback" />]);
}
